import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Protected } from "./components/Protected";
import { Login } from "./pages/Login";
import { RoastList } from "./pages/RoastList";
import { RoastDetail } from "./pages/RoastDetail";
import { RateRoast } from "./pages/RateRoast";
import { CorrectMilestone } from "./pages/CorrectMilestone";
import { RoastSuggestions } from "./pages/RoastSuggestions";
import { Ingestion } from "./pages/Ingestion";
import { CoffeeList } from "./pages/CoffeeList";
import { CoffeeDetail } from "./pages/CoffeeDetail";
import { Maintenance } from "./pages/Maintenance";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<RoastList />} />
        <Route path="roasts/:roastId" element={<RoastDetail />} />
        <Route path="roasts/:roastId/rate" element={<RateRoast />} />
        <Route path="roasts/:roastId/correct" element={<CorrectMilestone />} />
        <Route
          path="roasts/:roastId/suggestions"
          element={<RoastSuggestions />}
        />
        <Route path="coffees" element={<CoffeeList />} />
        <Route path="coffees/:coffeeId" element={<CoffeeDetail />} />
        <Route path="maintenance" element={<Maintenance />} />
        <Route path="ingestion" element={<Ingestion />} />
      </Route>
    </Routes>
  );
}
